/* eslint-disable import/prefer-default-export */
export const COLORS = {
  pink: '#ff9aa2',
  orange: '#ffdac1',
  green: '#b5ead7',
  purple: '#c7ceea',
  yellow: '#fff87f',
};

export const BACKGROUND_COLORS = {
  pink: 'bg-pink',
  orange: 'bg-orange',
  green: 'bg-green',
  purple: 'bg-purple',
  yellow: 'bg-yellow',
};
